// extracted by mini-css-extract-plugin
export var cardImage = "styles-module--cardImage--BVkWu";
export var flip = "styles-module--flip--GQL14";
export var img = "styles-module--img--J0rPu";
export var main = "styles-module--main--6bueA";
export var photoCard = "styles-module--photoCard--A4tvA";
export var text = "styles-module--text--KQx8+";
export var textWrapper = "styles-module--textWrapper--OcDNc";